import "core-js/modules/es.number.constructor.js";
//
//
//
//

export default {
  name: 'widget__mask',
  props: {
    maskOpacity: {
      // 蒙层透明度
      type: Number,
      default: 0.4
    }
  },
  mounted: function mounted() {
    var cssStr = "\n      position: fixed;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      overflow: hidden;\n      touch-action: none;\n      overscroll-behavior: none;\n    ";
    document.getElementsByTagName('body')[0].style.cssText = cssStr;
    document.body.style.cssText = cssStr;
  },
  destroyed: function destroyed() {
    var cssStr = 'overflow-y: auto; height: auto;';
    document.getElementsByTagName('body')[0].style.cssText = cssStr;
    document.body.style.cssText = cssStr;
  },
  methods: {
    triggerClick: function triggerClick() {
      this.$emit('click');
    }
  }
};